import Chip from '@components/v2/ui/Chip/Chip';
import Icon from '@components/v2/ui/Icon/Icon';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { Info, TicketPercent } from 'lucide-react';
import { BusinessPolicyVoucherDTO } from '../../../../services/modules/business-policies/businessPolicies.types';
import useVoucherRow from './hooks/useVoucherRow';

const RULES_TOOLTIP_MAX_WIDTH = 240;

interface VoucherRowProps {
  voucher: BusinessPolicyVoucherDTO;
}

const VoucherRow = ({ voucher }: VoucherRowProps) => {
  const { discountLabel, detailLabel, ruleLabels } = useVoucherRow(voucher);

  return (
    <Stack direction="row" sx={{ flex: 1, minWidth: 0, alignItems: 'center', gap: 1 }}>
      <Box sx={{ display: 'flex', flexShrink: 0, color: 'text.secondary' }}>
        <Icon icon={TicketPercent} size="md" />
      </Box>

      <Stack sx={{ flex: 1, minWidth: 0, gap: 0.5 }}>
        <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
          <Typography variant="body1" title={voucher.name} noWrap sx={{ flex: 1, minWidth: 0 }}>
            {voucher.name}
          </Typography>

          {discountLabel && <Chip label={discountLabel} size="extraSmall" sx={{ flexShrink: 0 }} />}
        </Stack>

        <Typography variant="micro1" color="text.secondary" title={detailLabel} noWrap>
          {detailLabel}
        </Typography>
      </Stack>

      <Tooltip
        placement="bottom-right"
        tabIndex={-1}
        TooltipContent={
          <Stack sx={{ gap: 0.5, maxWidth: RULES_TOOLTIP_MAX_WIDTH }}>
            {ruleLabels.map((rule) => (
              <Typography key={rule} variant="body2" color="inherit">
                • {rule}
              </Typography>
            ))}
          </Stack>
        }
      >
        <Box sx={{ display: 'flex', color: 'text.secondary' }}>
          <Icon icon={Info} size="sm" />
        </Box>
      </Tooltip>
    </Stack>
  );
};

export default VoucherRow;
